module.exports = __webpack_public_path__ + "img/contacto.f339ca0f.png";